module.exports = __webpack_public_path__ + "static/img/collins-logo.d7e73774.png";